// ============================================================================
// Vista — Login (/login)
// ============================================================================

import { mostrarToast } from '@plataforma/ui';

import { navegarA } from '../enrutador.js';
import { obtenerEstadoSesion, iniciarSesion } from '../estado-sesion.js';

export async function vistaLogin(contenedorRaiz) {
  const { sesion } = obtenerEstadoSesion();

  if (sesion) {
    navegarA('/');
    return;
  }

  contenedorRaiz.innerHTML = `
    <div class="pf-login">
      <form id="pf-form-login" class="pf-tarjeta pf-login__tarjeta">
        <h1 class="pf-login__titulo">Iniciar sesión</h1>
        <p class="pf-texto-suave pf-login__subtitulo">Accede a tu panel de tienda.</p>

        <div class="pf-campo">
          <label for="pf-email">Correo</label>
          <input type="email" id="pf-email" class="pf-campo__input" required autocomplete="email" />
        </div>

        <div class="pf-campo">
          <label for="pf-password">Contraseña</label>
          <input type="password" id="pf-password" class="pf-campo__input" required autocomplete="current-password" />
        </div>

        <button type="submit" class="pf-boton pf-boton--primario pf-boton--bloque">Entrar</button>

        <a href="#/cambiar-contrasena" class="pf-boton pf-boton--enlace" style="margin-top: 8px;">
          ¿Olvidaste tu contraseña?
        </a>

        <p class="pf-texto-suave" style="margin-top: 16px; text-align: center; font-size: var(--pf-tamano-sm);">
          ¿No tienes cuenta?
          <a
            href="${import.meta.env.VITE_APP_COMERCIAL_URL || '#'}/registro"
            class="pf-boton pf-boton--enlace"
          >Crear mi tienda</a>
        </p>
      </form>
    </div>
  `;

  const form = contenedorRaiz.querySelector('#pf-form-login');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = contenedorRaiz.querySelector('#pf-email').value.trim();
    const password = contenedorRaiz.querySelector('#pf-password').value;

    const btn = contenedorRaiz.querySelector('.pf-boton--bloque');
    const textoOriginal = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Entrando...';

    const { error } = await iniciarSesion(email, password);
    if (error) {
      btn.disabled = false;
      btn.textContent = textoOriginal;
      mostrarToast(error.message || 'Error al iniciar sesión.', { tono: 'peligro' });
      return;
    }

    navegarA('/');
  });
}
